import {dbRef} from "../../auth/FirebaseContext";
import {child, get} from "firebase/database";

export const getPaymentTransaction = async (transactionID) => {
    return (await get(child(dbRef, `/tempInvoices/${transactionID}`))).val();
}

